import { render, staticRenderFns } from "./PlanejamentoContratoFormAnexoArquivo.vue?vue&type=template&id=32107e2f&scoped=true"
import script from "./PlanejamentoContratoFormAnexoArquivo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAnexoArquivo.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoFormAnexoArquivo.vue?vue&type=style&index=0&id=32107e2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32107e2f",
  null
  
)

export default component.exports